  document.addEventListener("click", function (e) {
  const btn = e.target.closest(".t4s-pr-des-toggle");
  if (!btn) return;

  const wrapper = btn.closest(".product-description");
  const desc = wrapper.querySelector(".desc_container");

  const isExpanded = wrapper.classList.toggle("is-expanded");
  if(isExpanded){
    desc.innerHTML = desc.dataset.full

  }else {
    desc.textContent = desc.dataset.short;
  }

});